export const softwares = [
  {
    id: 'gold-radar',
    name: '金价雷达',
    categoryId: 'price',
    categoryName: '价格监控APP',
    version: 'v5.2.1',
    size: '42.6 MB',
    platform: 'iOS / Android / Windows',
    publishDate: '2026-09-28',
    downloads: 1286000,
    rating: 4.8,
    free: true,
    summary: '实时追踪黄金、白银报价，支持自定义到价提醒与多端同步，涨跌一目了然。',
    tags: ['到价提醒', '实时盯盘', '多端同步'],
    features: [
      '毫秒级行情刷新，覆盖现货黄金、纸黄金与黄金ETF',
      '自定义到价提醒，支持声音、震动与推送三种方式',
      '手机、平板与电脑多端同步自选列表',
      '涨跌幅看板与行情速览卡片，打开即可掌握走势',
    ],
    updates: [
      { version: 'v5.2.1', date: '2026-09-28', note: '新增黄金ETF行情分组，优化提醒延迟。' },
      { version: 'v5.1.0', date: '2026-08-12', note: '改进行情刷新性能，修复夜间推送异常。' },
    ],
    cover:
      'https://readdy.ai/api/search-image?query=Professional%20software%20dashboard%20mockup%20for%20a%20gold%20price%20monitoring%20app%2C%20dark%20navy%20interface%20with%20warm%20gold%20accent%20charts%2C%20clean%20minimal%20UI%2C%20soft%20studio%20lighting%2C%20neutral%20background%2C%20editorial%20tech%20product%20photography%20with%20high%20detail&width=640&height=400&seq=gold-soft-cover-01&orientation=landscape',
  },
  {
    id: 'gold-trend-master',
    name: '黄金趋势大师',
    categoryId: 'trend',
    categoryName: '趋势分析软件',
    version: 'v3.8.0',
    size: '128 MB',
    platform: 'Windows / macOS',
    publishDate: '2026-09-20',
    downloads: 962000,
    rating: 4.7,
    free: true,
    summary: '内置多种技术指标与形态识别模型，帮助判断黄金价格的中短期趋势方向。',
    tags: ['技术指标', '形态识别', '智能预测'],
    features: [
      '集成MACD、KDJ、布林带等常用技术指标',
      '自动识别头肩顶、三角形等经典形态',
      '多周期联动分析，日线周线月线一键切换',
      '支持自定义指标公式与策略回测',
    ],
    updates: [
      { version: 'v3.8.0', date: '2026-09-20', note: '新增智能预测模块，指标库扩充至32种。' },
      { version: 'v3.6.4', date: '2026-07-30', note: '优化形态识别准确率。' },
    ],
    cover:
      'https://readdy.ai/api/search-image?query=Professional%20desktop%20analytics%20software%20mockup%20with%20candlestick%20chart%20and%20technical%20indicators%20for%20gold%20trading%2C%20deep%20navy%20and%20warm%20gold%20color%20scheme%2C%20minimal%20clean%20interface%2C%20soft%20neutral%20background%2C%20high%20detail%20tech%20product%20photography&width=640&height=400&seq=gold-soft-cover-02&orientation=landscape',
  },
  {
    id: 'gold-mobile-quote',
    name: '掌上黄金行情',
    categoryId: 'news',
    categoryName: '行情资讯',
    version: 'v6.1.3',
    size: '38.2 MB',
    platform: 'iOS / Android',
    publishDate: '2026-09-15',
    downloads: 1530000,
    rating: 4.6,
    free: true,
    summary: '聚合黄金市场快讯、机构研报与财经日历，重要事件不错过。',
    tags: ['实时快讯', '机构研报', '财经日历'],
    features: [
      '7×24小时黄金市场快讯推送',
      '精选机构研报与分析师观点解读',
      '财经日历提醒，重要数据提前预告',
      '个性化订阅关注栏目',
    ],
    updates: [
      { version: 'v6.1.3', date: '2026-09-15', note: '资讯订阅支持自定义关键词。' },
      { version: 'v6.0.0', date: '2026-06-18', note: '全新资讯首页改版上线。' },
    ],
    cover:
      'https://readdy.ai/api/search-image?query=Mobile%20news%20app%20interface%20mockup%20showing%20financial%20market%20news%20feed%20about%20gold%2C%20navy%20and%20gold%20accent%20tones%2C%20clean%20minimal%20layout%2C%20soft%20studio%20lighting%2C%20neutral%20background%2C%20editorial%20tech%20photography&width=640&height=400&seq=gold-soft-cover-03&orientation=landscape',
  },
  {
    id: 'gold-wealth-butler',
    name: '金管家理财助手',
    categoryId: 'wealth',
    categoryName: '理财工具',
    version: 'v2.9.4',
    size: '56.8 MB',
    platform: 'iOS / Android / Web',
    publishDate: '2026-09-08',
    downloads: 734000,
    rating: 4.5,
    free: true,
    summary: '黄金定投计算、收益测算与资产配置规划，助你稳健打理黄金类资产。',
    tags: ['定投计算', '收益测算', '资产配置'],
    features: [
      '黄金定投计划模拟，自动计算累计收益',
      '多场景收益测算器，支持复利与分批投入',
      '资产配置建议，黄金占比一目了然',
      '记账与持仓管理，收益曲线可视化',
    ],
    updates: [
      { version: 'v2.9.4', date: '2026-09-08', note: '新增定投提醒与收益日报。' },
      { version: 'v2.8.0', date: '2026-05-22', note: '优化资产配置计算逻辑。' },
    ],
    cover:
      'https://readdy.ai/api/search-image?query=Personal%20finance%20and%20investment%20calculator%20app%20mockup%20with%20gold%20savings%20plan%20charts%2C%20navy%20and%20warm%20gold%20palette%2C%20clean%20minimal%20UI%2C%20soft%20neutral%20background%2C%20editorial%20tech%20product%20photography%20high%20detail&width=640&height=400&seq=gold-soft-cover-04&orientation=landscape',
  },
  {
    id: 'gold-spot-desk',
    name: '现货黄金交易台',
    categoryId: 'trade',
    categoryName: '交易平台',
    version: 'v4.5.2',
    size: '156 MB',
    platform: 'Windows / macOS / Web',
    publishDate: '2026-08-30',
    downloads: 618000,
    rating: 4.4,
    free: true,
    summary: '模拟交易与实盘下单一体化，配备风控管理，熟悉黄金交易全流程。',
    tags: ['模拟交易', '实盘下单', '风控管理'],
    features: [
      '模拟账户零风险练习下单流程',
      '一键切换实盘，支持多品种挂单',
      '止盈止损与仓位风控提醒',
      '交易复盘与操作记录导出',
    ],
    updates: [
      { version: 'v4.5.2', date: '2026-08-30', note: '新增风控提醒与行情预警。' },
      { version: 'v4.4.0', date: '2026-06-05', note: '提升下单撮合速度。' },
    ],
    cover:
      'https://readdy.ai/api/search-image?query=Trading%20platform%20desktop%20mockup%20with%20order%20book%20and%20price%20charts%20for%20spot%20gold%2C%20deep%20navy%20interface%20with%20gold%20accents%2C%20clean%20professional%20layout%2C%20soft%20neutral%20background%2C%20editorial%20tech%20photography&width=640&height=400&seq=gold-soft-cover-05&orientation=landscape',
  },
  {
    id: 'gold-etf-helper',
    name: '黄金ETF助手',
    categoryId: 'wealth',
    categoryName: '理财工具',
    version: 'v1.7.9',
    size: '33.4 MB',
    platform: 'iOS / Android',
    publishDate: '2026-08-22',
    downloads: 512000,
    rating: 4.5,
    free: true,
    summary: '专注黄金ETF的净值跟踪、溢价提醒与定投计划管理。',
    tags: ['定投计算', '净值跟踪', '溢价提醒'],
    features: [
      '主流黄金ETF净值与溢价实时跟踪',
      '溢价异常提醒，把握折溢价机会',
      'ETF定投计划管理与收益统计',
      '持仓对比功能，直观查看配置比例',
    ],
    updates: [
      { version: 'v1.7.9', date: '2026-08-22', note: '新增溢价提醒阈值设置。' },
      { version: 'v1.6.0', date: '2026-05-10', note: '支持更多黄金ETF品种。' },
    ],
    cover:
      'https://readdy.ai/api/search-image?query=ETF%20investment%20app%20mockup%20with%20net%20value%20line%20chart%20and%20portfolio%20donut%20chart%2C%20navy%20and%20gold%20color%20scheme%2C%20clean%20minimal%20interface%2C%20soft%20neutral%20background%2C%20high%20detail%20editorial%20tech%20photography&width=640&height=400&seq=gold-soft-cover-06&orientation=landscape',
  },
  {
    id: 'gold-quote-pro',
    name: '金投行情通',
    categoryId: 'news',
    categoryName: '行情资讯',
    version: 'v7.3.0',
    size: '48.1 MB',
    platform: 'iOS / Android / Windows',
    publishDate: '2026-08-14',
    downloads: 1180000,
    rating: 4.7,
    free: true,
    summary: '全球黄金市场行情一屏尽览，专业图表与多市场联动分析。',
    tags: ['实时快讯', '全球行情', '专业图表'],
    features: [
      '伦敦金、纽约金、上海金多市场同屏对比',
      '专业K线图表，支持画线标注与截图分享',
      '行情快讯与重要数据同步推送',
      '自选行情分组与云端同步',
    ],
    updates: [
      { version: 'v7.3.0', date: '2026-08-14', note: '新增多市场同屏对比功能。' },
      { version: 'v7.1.2', date: '2026-06-28', note: '优化图表加载速度。' },
    ],
    cover:
      'https://readdy.ai/api/search-image?query=Financial%20market%20terminal%20app%20mockup%20with%20multiple%20price%20charts%20and%20watchlist%2C%20deep%20navy%20and%20warm%20gold%20tones%2C%20clean%20minimal%20UI%2C%20soft%20neutral%20background%2C%20editorial%20tech%20photography%20high%20detail&width=640&height=400&seq=gold-soft-cover-07&orientation=landscape',
  },
  {
    id: 'gold-dca-calc',
    name: '黄金定投计算器',
    categoryId: 'wealth',
    categoryName: '理财工具',
    version: 'v1.4.2',
    size: '18.6 MB',
    platform: 'iOS / Android / Web',
    publishDate: '2026-08-05',
    downloads: 405000,
    rating: 4.6,
    free: true,
    summary: '轻量好用的黄金定投收益测算工具，随时预估长期回报。',
    tags: ['定投计算', '收益测算', '轻量工具'],
    features: [
      '按日/周/月设定定投频率与金额',
      '历史金价回测，直观查看定投效果',
      '复利收益与成本均价一键计算',
      '结果可导出分享给好友',
    ],
    updates: [
      { version: 'v1.4.2', date: '2026-08-05', note: '新增历史回测区间选择。' },
      { version: 'v1.3.0', date: '2026-06-12', note: '优化计算精度与界面。' },
    ],
    cover:
      'https://readdy.ai/api/search-image?query=Minimal%20investment%20calculator%20app%20mockup%20with%20savings%20growth%20chart%20and%20numbers%2C%20navy%20and%20gold%20accent%20tones%2C%20clean%20simple%20UI%2C%20soft%20neutral%20background%2C%20editorial%20tech%20photography&width=640&height=400&seq=gold-soft-cover-08&orientation=landscape',
  },
  {
    id: 'gold-kline-expert',
    name: 'K线黄金分析专家',
    categoryId: 'trend',
    categoryName: '趋势分析软件',
    version: 'v2.6.7',
    size: '96 MB',
    platform: 'Windows / macOS / Web',
    publishDate: '2026-07-28',
    downloads: 528000,
    rating: 4.5,
    free: true,
    summary: '专注K线形态与量价分析，输出可视化的趋势判断参考。',
    tags: ['形态识别', '量价分析', '智能预测'],
    features: [
      '三十余种K线形态自动标注',
      '量价关系分析，识别放量突破',
      '趋势通道自动绘制与支撑压力位提示',
      '分析结论可生成图表报告',
    ],
    updates: [
      { version: 'v2.6.7', date: '2026-07-28', note: '新增支撑压力位自动标注。' },
      { version: 'v2.5.0', date: '2026-05-30', note: '扩充K线形态库。' },
    ],
    cover:
      'https://readdy.ai/api/search-image?query=Candlestick%20pattern%20analysis%20software%20mockup%20with%20annotated%20charts%20and%20trend%20channels%2C%20deep%20navy%20with%20gold%20highlights%2C%20clean%20minimal%20layout%2C%20soft%20neutral%20background%2C%20editorial%20tech%20photography&width=640&height=400&seq=gold-soft-cover-09&orientation=landscape',
  },
  {
    id: 'gold-price-alert',
    name: '金价提醒助手',
    categoryId: 'price',
    categoryName: '价格监控APP',
    version: 'v3.2.0',
    size: '26.9 MB',
    platform: 'iOS / Android',
    publishDate: '2026-07-19',
    downloads: 866000,
    rating: 4.7,
    free: true,
    summary: '专注到价提醒的小工具，价格一触即达，省心盯盘。',
    tags: ['到价提醒', '多端同步', '轻量工具'],
    features: [
      '支持多条价格提醒同时设置',
      '涨跌幅百分比提醒，把握波动机会',
      '静音时段设置，夜间不打扰',
      '提醒记录可回溯查看',
    ],
    updates: [
      { version: 'v3.2.0', date: '2026-07-19', note: '新增涨跌幅提醒模式。' },
      { version: 'v3.0.1', date: '2026-05-16', note: '优化提醒到达速度。' },
    ],
    cover:
      'https://readdy.ai/api/search-image?query=Mobile%20price%20alert%20app%20mockup%20with%20notification%20cards%20and%20gold%20price%20ticker%2C%20navy%20and%20gold%20color%20scheme%2C%20clean%20minimal%20UI%2C%20soft%20neutral%20background%2C%20high%20detail%20editorial%20tech%20photography&width=640&height=400&seq=gold-soft-cover-10&orientation=landscape',
  },
  {
    id: 'gold-invest-academy',
    name: '黄金投资学院',
    categoryId: 'learn',
    categoryName: '学习工具',
    version: 'v4.0.5',
    size: '74.3 MB',
    platform: 'iOS / Android / Web',
    publishDate: '2026-07-10',
    downloads: 592000,
    rating: 4.8,
    free: true,
    summary: '从入门到进阶的黄金投资课程与名词词典，新手也能快速上手。',
    tags: ['入门课程', '名词词典', '实战案例'],
    features: [
      '体系化课程：基础、行情、策略三大模块',
      '黄金投资名词词典，边查边学',
      '真实案例复盘，理解市场逻辑',
      '学习进度记录与阶段测验',
    ],
    updates: [
      { version: 'v4.0.5', date: '2026-07-10', note: '新增实战案例复盘栏目。' },
      { version: 'v3.8.0', date: '2026-04-25', note: '课程体系全面升级。' },
    ],
    cover:
      'https://readdy.ai/api/search-image?query=Online%20learning%20app%20mockup%20about%20gold%20investing%20courses%20with%20lesson%20cards%2C%20navy%20and%20warm%20gold%20tones%2C%20clean%20minimal%20interface%2C%20soft%20neutral%20background%2C%20editorial%20tech%20photography%20high%20detail&width=640&height=400&seq=gold-soft-cover-11&orientation=landscape',
  },
  {
    id: 'gold-metal-quote',
    name: '贵金属行情宝',
    categoryId: 'price',
    categoryName: '价格监控APP',
    version: 'v5.6.1',
    size: '45.7 MB',
    platform: 'iOS / Android / Windows',
    publishDate: '2026-06-30',
    downloads: 702000,
    rating: 4.6,
    free: true,
    summary: '黄金白银铂金行情一站掌握，贵金属报价与走势全覆盖。',
    tags: ['实时盯盘', '贵金属行情', '多端同步'],
    features: [
      '黄金、白银、铂金、钯金全品种报价',
      '国内外市场价差对比',
      '走势图与历史数据查询',
      '自选分组与桌面小组件',
    ],
    updates: [
      { version: 'v5.6.1', date: '2026-06-30', note: '新增桌面小组件报价。' },
      { version: 'v5.5.0', date: '2026-04-18', note: '扩充贵金属品种。' },
    ],
    cover:
      'https://readdy.ai/api/search-image?query=Precious%20metals%20trading%20app%20mockup%20with%20gold%20silver%20platinum%20prices%20and%20trend%20lines%2C%20deep%20navy%20and%20gold%20accent%20palette%2C%20clean%20minimal%20UI%2C%20soft%20neutral%20background%2C%20editorial%20tech%20photography&width=640&height=400&seq=gold-soft-cover-12&orientation=landscape',
  },
];